export default "__VITE_ASSET__BJMxD4Cx__"